import { render, staticRenderFns } from "./dashboardSlider.vue?vue&type=template&id=2d36f388&"
import script from "./dashboardSlider.vue?vue&type=script&lang=js&"
export * from "./dashboardSlider.vue?vue&type=script&lang=js&"
import style0 from "./dashboardSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports